((Redactor) => {
  Redactor.add("plugin", "embedded", {
    modals: {
      embedded: `<form action="" id="embeddedForm" name="embeddedForm">
              <div class="form-item">
                  <label>## embedLabel ##</label>
                  <textarea name="widget" id="widget_code" style="height: 200px; width: 100%; padding: 8px; border: 1px solid #ddd; border-radius: 4px;" placeholder="## embedPlaceholder ##"></textarea>
                  <span class="embedded-error" style="color: red; font-size: 12px; display: block; margin-top: 5px;"></span>
              </div>
          </form>`,
    },

    translations: {
      en: {
        embedded: I18n.t("redactor_embedded"),
        "embedded-label": I18n.t("redactor_embedded_label"),
        embedLabel: "Paste embed code",
        embedPlaceholder: "Paste YouTube, Twitter, Instagram embed code here...",
        embedError: "Embedded input is not valid!",
      },
      ru: {
        embedded: I18n.t("redactor_embedded"),
        "embedded-label": I18n.t("redactor_embedded_label"),
        embedLabel: "Вставьте код для встраивания",
        embedPlaceholder: "Вставьте код встраивания YouTube, Twitter, Instagram здесь...",
        embedError: "Введенный код встраивания недействителен!",
      },
    },

    init(app) {
      this.app = app;
      this.lang = app.lang;
      this.toolbar = app.toolbar;
      this.component = app.component;
      this.insertion = app.insertion;
      this.inspector = app.inspector;
      this.selection = app.selection;
    },

    start() {
      const buttonData = {
        title: this.lang.get("embedded"),
        api: "plugin.embedded.open",
      };
      this.toolbar.addButton("embedded", buttonData);
    },

    open() {
      this.currentItem = this._getCurrent();

      const options = {
        title: this.lang.get("embedded-label"),
        width: "600px",
        name: "embedded",
        handle: "insert",
        commands: {
          insert: {
            title: this.currentItem ? this.lang.get("save") : this.lang.get("insert"),
          },
          cancel: { title: this.lang.get("cancel") },
        },
      };

      this.app.api("module.modal.build", options);
    },

    remove(node) {
      this.component.remove(node);
    },

    onmodal: {
      embedded: {
        opened: (modal, form) => {
          const widgetField = form.getField("widget");
          widgetField.focus();
          if (this.currentItem) {
            const code = decodeURI(
              this.currentItem.getAttribute("data-widget-code")
            );
            widgetField.val(code);
          }
        },
        insert(modal, form) {
          const embeddedForm = document.forms["embeddedForm"];
          const widgetCode = embeddedForm.querySelector("#widget_code");
          const embeddedError = embeddedForm.querySelector(".embedded-error");
          
          if (!widgetCode.value.trim()) {
            embeddedError.innerText = this.lang.get("embedError");
            return;
          }

          embeddedError.innerText = "";
          this._insertWidget(widgetCode.value.trim());
        },
      },
    },

    oncontextbar(e, contextbar) {
      const data = this.inspector.parse(e.target);
      if (!data.isFigcaption() && data.isComponentType("widget")) {
        const node = data.getComponent();
        const buttons = {
          edit: {
            title: this.lang.get("edit"),
            api: "plugin.embedded.open",
            args: node,
          },
          remove: {
            title: this.lang.get("delete"),
            api: "plugin.embedded.remove",
            args: node,
          },
        };

        contextbar.set(e, node, buttons, "bottom");
      }
    },

    onbutton: {
      embedded: {
        observe: (button) => this._observeButton(button),
      },
    },

    _getCurrent() {
      const current = this.selection.getCurrent();
      const data = this.inspector.parse(current);
      if (data.isComponentType("widget")) {
        return this.component.build(data.getComponent());
      }
    },

    _insertWidget(widgetTxt) {
      const blockValidationReg = /<blockquote[\s\S]*<\/blockquote>/;
      const scriptValidationReg = /<script[\s\S]*<\/script>/;
      const iframeValidationReg = /<iframe[\s\S]*<\/iframe>/;

      if (
        (blockValidationReg.test(widgetTxt) &&
          scriptValidationReg.test(widgetTxt)) ||
        iframeValidationReg.test(widgetTxt)
      ) {
        this.app.api("module.modal.close");

        if (widgetTxt.trim() === "") return;

        const embedCode = widgetTxt.replace(/<script[\s\S]*<\/script>/g, "");
        
        // Create figure element for the widget
        const figure = document.createElement("figure");
        figure.setAttribute("data-redactor-type", "widget");
        figure.setAttribute("data-widget-code", encodeURI(embedCode.trim()));
        figure.setAttribute("contenteditable", "false");
        figure.innerHTML = embedCode;
        
        this.insertion.insertHtml(figure);

        // Load Twitter widget script if needed
        if (!document.querySelector('script[src*="platform.twitter.com"]')) {
          const script = document.createElement("script");
          script.src = "https://platform.twitter.com/widgets.js";
          document.body.appendChild(script);
        }
      } else {
        alert(this.lang.get("embedError"));
      }
    },

    _isHtmlString(html) {
      return !(typeof html === "string" && !/^\s*<(\w+|!)[^>]*>/.test(html));
    },

    _observeButton(button) {
      const current = this.selection.getCurrent();
      const data = this.inspector.parse(current);
      data.isComponentType("table") ? button.disable() : button.enable();
    },
  });
})(Redactor);

